import { Box, Button, Typography } from '@mui/material';
import { createWhatsAppUrl } from './siteConfig';
import { vehiclePrices } from './vehiclePrices';

function ModelPriceSummary({ model, priceKey }) {
  const variants = vehiclePrices[priceKey];

  return (
    <Box
      component='section'
      aria-label={`Harga ${model} NIK 2026`}
      sx={{ maxWidth: 1180, mx: 'auto', px: { xs: 2, md: 5 }, py: 5 }}
    >
      <Typography
        component='h2'
        sx={{ fontSize: { xs: '1.8rem', md: '2.4rem' }, fontWeight: 700 }}
      >
        Harga {model} NIK 2026
      </Typography>
      {variants.map((item) => (
        <Box
          key={item.type}
          sx={{
            mt: 2,
            p: 3,
            backgroundColor: '#f4f6f7',
            border: '1px solid #dde3e6',
          }}
        >
          <Typography component='h3' sx={{ fontWeight: 700 }}>
            {item.type}
          </Typography>
          <Typography
            sx={{ mt: 1, fontSize: '2rem', fontWeight: 700, color: '#1976d2' }}
          >
            {item.price}
          </Typography>
          <Typography sx={{ mt: 1, color: '#52616a' }}>
            {item.description} · OTR Jakarta
          </Typography>
          <Button
            href={createWhatsAppUrl(
              `Halo Junius, saya ingin penawaran pembelian ${model} ${item.type} dengan harga ${item.price}.`,
            )}
            target='_blank'
            rel='noopener noreferrer'
            variant='contained'
            sx={{ mt: 2, textTransform: 'none' }}
          >
            Minta penawaran pembelian
          </Button>
        </Box>
      ))}
    </Box>
  );
}

export default ModelPriceSummary;
